module.exports = __webpack_public_path__ + "static/media/order-white.604c98ff.svg";